import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';


import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import LocatorList from '../../components/rts/Locator/LocatorList';
import LocatorMap from '../../components/rts/Locator/LocatorMap';
import LocatorFilter from '../../components/rts/Locator/LocatorFilter';
import LocatorMode from '../../components/rts/Locator/LocatorMode';

import { useSessionContext } from '../../contexts/SessionContext';

export default function LocatorPage( props ) {
    //console.debug("RTS Break LocatorPage");

    const {user, userAuthToken, apiRoot} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [mode, setMode] = useState(-2);
    const [data, setData] = useState([]);
    const [hasError, setHasError] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");

    const [locatorFilters, setLocatorFilters] = useState({});
    
    const [filter, setFilter] = useState(
        {
            "user":user, 
            "product":null, 
            "reelType":null,
            "minLength":0,
            "maxAge":0,
            "sortBy":0 
        }
    );


    const fetchData = useCallback(() => {
        let apiURL = apiRoot + "/Locator/GetLocatorList";
        axios
        .post(
            apiURL,
            filter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
                if(response.data.length === 0)
                {
                    setMode(-1);
                }
                setIsLoading(false);
                setHasError(false);
            }
            else{
                setMode(-1);
            }
        })
        .catch(error => {
            setIsLoading(false);
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token, filter]);


    useEffect(() => {
        if(mode > -2){
            fetchData();
        }
    }, [props, mode, filter, fetchData]);

    
    useEffect(() => {
        props.setIsModalFx(false);
        setIsLoading(false);
        setHasError(false);
    },[]);


    function dataFilter(args){
        if(args.product == null && args.reelType == null){
                setErrorTitle("Input Required");
                setErrorBody("A Product or Reel Type must be selected in order to continue");
                setShowErrorModal(true);
                return;            
        }

        setIsLoading(true);
        let locFilter = {"user": user,
                        "product": args.product,
                        "reelType": args.reelType, 
                        "minLength": args.minLength,
                        "maxAge": args.maxAge,
                        "sortBy": args.sortBy 
                    }

        setFilter(locFilter);
        setMode(0);
    }


    function openBaseMode(args){
        setIsLoading(true);
        //setBaseMode(args);
        setMode(args);
        setIsLoading(false);
    }


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>         
        <Box id="pageBox">
            <Box id="filterBox">
                <LocatorFilter filter={filter} setFilterFx={dataFilter} locatorFilters={locatorFilters} />            
            </Box>
            <Box id="modeBox">
                <LocatorMode data={data} modeFx={openBaseMode} mode={mode} reelCount={data===null?0:data.length} />            
            </Box>            
            <Box id="contentBox">
                {mode===-2?<Box sx={{textAlign:"center", pt:2}}><Typography variant='h5'>Select the needed filters and click the Find button</Typography></Box>:""}
                {mode===-1?<Box sx={{textAlign:"center", pt:2}}><Typography variant='h5'>No Data Found</Typography></Box>:""}
                {mode===0?<LocatorList data={data} user={user} />:""}
                {mode===1?<LocatorMap data={data} user={user} />:""}
            </Box> 
        </Box>
        </>
    );
}

